import React, { useEffect, useRef } from "react";
import { connect } from "react-redux";
import { Field, formValueSelector } from "redux-form";
import { months } from "../../../../../../Utils/months";
import { renderDollar, renderNumberKG, renderDollarDisabled, renderNumberKGDisabled, renderCurrencyDisabled, renderCurrency } from "../../../../../../Utils/renderField/renderField";

const LatexTable = (props) => {

    const { change, data_solido, currency, comparativoData } = props;

    const solido_data = (data_solido) ? data_solido : {};

    if (!solido_data) {
        return null;
    }

    const calculateMonthlyValues = () => {
        const tempData = {};
        const getNumber = (value) => parseFloat(value) || 0;

        for (var i = 0; i < months.length; i++) {
            const month = months[i];
            const prevMonth = i > 0 ? months[i - 1] : null;

            const current = solido_data[month] || {};
            const prodDelMes = current.produccion_del_mes || {};
            const costoVtaMes = current.costo_vta_del_mes || {};

            let previousFinal = {};
            if (prevMonth) {
                if (tempData[prevMonth] && tempData[prevMonth].prod_termin_final) {
                    previousFinal = tempData[prevMonth].prod_termin_final;
                } else if (
                    solido_data[prevMonth] &&
                    solido_data[prevMonth].prod_termin_final
                ) {
                    previousFinal = solido_data[prevMonth].prod_termin_final;
                }
            }

            let kgsSecosAnterior = 0;
            let costoKgAnterior = 0;

            if (i === 0) {
                const prodTermMesAnterior = current.prod_term_mes_anterior || {};
                kgsSecosAnterior = getNumber(prodTermMesAnterior.kgs_secos);
                costoKgAnterior = getNumber(prodTermMesAnterior.costo_kg_seco);
            } else {
                // Lógica mejorada: Verificar si el dato actual es igual al anterior (no ponderado)
                const comparativoSolidoData = comparativoData && 
                    comparativoData.SolidosData && 
                    comparativoData.SolidosData.ProdTerminFinal && 
                    comparativoData.SolidosData.ProdTerminFinal[prevMonth];
                
                const comparativoSolidoDataActual = comparativoData && 
                    comparativoData.SolidosData && 
                    comparativoData.SolidosData.ProdTerminFinal && 
                    comparativoData.SolidosData.ProdTerminFinal[month];
                
                // Verificar si está ponderado: si el mes actual es diferente al anterior
                const estaGrabadoElMes = comparativoSolidoData && comparativoSolidoDataActual &&
                    (Math.abs(getNumber(comparativoSolidoData.KgSecos) - getNumber(comparativoSolidoDataActual.KgSecos)) > 0.01 ||
                     Math.abs(getNumber(comparativoSolidoData.CostoKgSec) - getNumber(comparativoSolidoDataActual.CostoKgSec)) > 0.00001);
                
                if (comparativoSolidoData && 
                    (getNumber(comparativoSolidoData.KgSecos) > 0 || getNumber(comparativoSolidoData.CostoKgSec) > 0) &&
                    estaGrabadoElMes) {
                    // Usar datos del comparativo si están disponibles, no son cero Y están ponderados
                    kgsSecosAnterior = getNumber(comparativoSolidoData.KgSecos);
                    costoKgAnterior = getNumber(comparativoSolidoData.CostoKgSec);
                    
                    // Actualizar los campos del formulario con los datos del comparativo
                    change(`solido_data.${month}.prod_term_mes_anterior.kgs_secos`, kgsSecosAnterior);
                    change(`solido_data.${month}.prod_term_mes_anterior.costo_kg_seco`, costoKgAnterior);
                    change(`solido_data.${month}.prod_term_mes_anterior.valor_total`, kgsSecosAnterior * costoKgAnterior);
                } else {
                    // Usar datos del presupuesto (mes anterior del mismo formulario)
                    const prodTermMesAnterior = current.prod_term_mes_anterior || {};
                    kgsSecosAnterior = getNumber(prodTermMesAnterior.kgs_secos);
                    costoKgAnterior = getNumber(prodTermMesAnterior.costo_kg_seco);
                }
            }

            const valorTotalAnterior = (kgsSecosAnterior * costoKgAnterior).toFixed(2);

            const prodTermDisponibleKgsSecos = (
                getNumber(prodDelMes.kgs_secos) + kgsSecosAnterior
            ).toFixed(2);

            const prodTermDisponibleValorTotal = (
                getNumber(prodDelMes.valor_total) + parseFloat(valorTotalAnterior)
            ).toFixed(2);

            const costoPromedioDisponible =
                prodTermDisponibleKgsSecos > 0
                    ? prodTermDisponibleValorTotal / prodTermDisponibleKgsSecos
                    : 0;

            const prodTerminKgsSecos = (
                prodTermDisponibleKgsSecos - getNumber(costoVtaMes.kgs_secos)
            ).toFixed(2);

            const valorTotalFinal = (prodTerminKgsSecos * costoPromedioDisponible).toFixed(2);

            // Guardar todo en memoria antes de aplicar cambios
            tempData[month] = {
                prod_term_mes_anterior: {
                    kgs_secos: kgsSecosAnterior,
                    costo_kg_seco: costoKgAnterior,
                    valor_total: valorTotalAnterior,
                },
                prod_term_disponible: {
                    kgs_secos: prodTermDisponibleKgsSecos,
                    costo_kg_seco: costoPromedioDisponible,
                    valor_total: prodTermDisponibleValorTotal,
                },
                prod_termin_final: {
                    kgs_secos: prodTerminKgsSecos,
                    costo_kg_seco: costoPromedioDisponible,
                    valor_total: valorTotalFinal,
                },
            };
        }

        // Aplicar los cambios al formulario después de calcular todo
        for (var j = 0; j < months.length; j++) {
            const month = months[j];
            const temp = tempData[month];
            if (!temp) continue;

            // COMENTADO: No sobrescribir datos que vienen del backend para meses > enero
            // Solo aplicar cambios para enero (mes editable)
            if (j === 0) {
                change(`solido_data.${month}.prod_term_mes_anterior.kgs_secos`, temp.prod_term_mes_anterior.kgs_secos);
                change(`solido_data.${month}.prod_term_mes_anterior.costo_kg_seco`, temp.prod_term_mes_anterior.costo_kg_seco);
                change(`solido_data.${month}.prod_term_mes_anterior.valor_total`, temp.prod_term_mes_anterior.valor_total);
            }

            change(`solido_data.${month}.prod_term_disponible.kgs_secos`, temp.prod_term_disponible.kgs_secos);
            change(`solido_data.${month}.prod_term_disponible.costo_kg_seco`, temp.prod_term_disponible.costo_kg_seco);
            change(`solido_data.${month}.prod_term_disponible.valor_total`, temp.prod_term_disponible.valor_total);

            change(`solido_data.${month}.prod_termin_final.kgs_secos`, temp.prod_termin_final.kgs_secos);
            change(`solido_data.${month}.prod_termin_final.costo_kg_seco`, temp.prod_termin_final.costo_kg_seco);
            change(`solido_data.${month}.prod_termin_final.valor_total`, temp.prod_termin_final.valor_total);
        }
    };
    
    const executedRef = useRef(false);

    useEffect(() => {
        if (executedRef.current) return;

        const hasLatexData = months.some((month) => {
            const data = solido_data[month];
            return data && Object.keys(data).length > 0;
        });

        if (hasLatexData) {
            calculateMonthlyValues();
            executedRef.current = true;
        }
    }, [solido_data]);

    const rowDescriptionClassName = "text-left table-fixed-cell-left-0 bg-white text-nowrap td--shadow-right";

    return (
        <div className="reports__table-bg">
            <div className="reports-table__container">
                <table className="table mb-0 text-center min-w-500">
                    <thead>
                        <tr>
                            <th rowSpan={2} className="text-left table-fixed-cell-left-0 tr--border-top tr--border-left td--shadow-right">&nbsp;</th>
                            {months.map((_, index) => (
                                <th key={index} colSpan={3} className={`th--border ${index === 0 ? "tr--no-border-left" : ""}`}>{index + 1}</th>
                            ))}
                        </tr>
                        <tr className="tr--no-radius tr--border-top">
                            {months.map((_, index) => (
                                <React.Fragment key={index}>
                                    <th className={index > 0 ? "tr--border-left" : ""}>Kgs Secos</th>
                                    <th>Costo Kg Sec</th>
                                    <th className="tr--border-right">Valor total</th>
                                </React.Fragment>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {[
                            { label: "Entradas MP a producción", key: "entradas_mp_a_produccion", style: '' },
                            { label: "(+) Gtos. De compra de MP", key: "gtos_de_compra_de_mp", style: '' },
                            { label: "(+) Cto. De Proceso", key: "cto_de_proceso", style: '' },
                            { label: "(=) Producción del mes", key: "produccion_del_mes", style: ' celda-totales ' },
                        ].map((row, rowIndex) => (
                            <tr key={rowIndex}>
                                <td className={row.style + rowDescriptionClassName}>{row.label}</td>
                                {months.map((month, index) => {
                                    const monthClass = index % 2 === 0 ? "" : " month-dark";
                                    return (
                                        <React.Fragment key={index}>
                                            <td className={row.style + monthClass}>
                                                <Field
                                                    name={`solido_data.${month}.${row.key}.kgs_secos`}
                                                    type="text"
                                                    component={renderNumberKGDisabled}
                                                    className="form-control"
                                                    placeholder='0.00'
                                                />
                                            </td>
                                            <td className={row.style + monthClass}>
                                                <Field
                                                    name={`solido_data.${month}.${row.key}.costo_kg_seco`}
                                                    type="text"
                                                    component={currency !== 'GTQ' ? renderDollarDisabled : renderCurrencyDisabled}
                                                    className="form-control"
                                                    placeholder='$0.00'
                                                    decimalScale={5}
                                                />
                                            </td>
                                            <td className={row.style + monthClass + ' tr--border-right'}>
                                                <Field
                                                    name={`solido_data.${month}.${row.key}.valor_total`}
                                                    type="text"
                                                    component={currency !== 'GTQ' ? renderDollarDisabled : renderCurrencyDisabled}
                                                    className="form-control"
                                                    placeholder='$0.00'
                                                />
                                            </td>
                                        </React.Fragment>
                                    )
                                })}
                            </tr>
                        ))}
                        <tr className="tr--border-top">
                            <td className={rowDescriptionClassName}>(+) Prod. Term. Mes anterior</td>
                            {months.map((month, index) => {
                                const previousMonth = index > 0 ? months[index - 1] : null;
                                const monthClass = index % 2 === 0 ? "" : " month-dark";
                                return (
                                    <React.Fragment key={index}>
                                        <td className={monthClass}>
                                            {index === 0 ? (
                                                <Field
                                                    name={`solido_data.${month}.prod_term_mes_anterior.kgs_secos`}
                                                    type="text"
                                                    component={renderNumberKG}
                                                    className="form-control"
                                                    placeholder='0.0 kg'
                                                    isReport
                                                    onBlur={calculateMonthlyValues}
                                                />
                                            ) : (
                                                <Field
                                                    name={`solido_data.${month}.prod_term_mes_anterior.kgs_secos`}
                                                    type="text"
                                                    component={renderNumberKGDisabled}
                                                    className="form-control"
                                                    placeholder='0.0 kg'
                                                />
                                            )}
                                        </td>
                                        <td className={monthClass}>
                                            {index === 0 ? (
                                                <Field
                                                    name={`solido_data.${month}.prod_term_mes_anterior.costo_kg_seco`}
                                                    type="text"
                                                    component={currency !== 'GTQ' ? renderDollar : renderCurrency}
                                                    className="form-control"
                                                    placeholder="$ 0.00"
                                                    decimalScale={5}
                                                    onBlur={calculateMonthlyValues}

                                                />
                                            ) : (
                                                <Field
                                                    name={`solido_data.${month}.prod_term_mes_anterior.costo_kg_seco`}
                                                    type="text"
                                                    component={currency !== 'GTQ' ? renderDollarDisabled : renderCurrencyDisabled}
                                                    className="form-control"
                                                    decimalScale={5}
                                                    placeholder="$ 0.00"
                                                />
                                            )}
                                        </td>
                                        <td className={monthClass + ' tr--border-right'}>
                                            <Field
                                                name={`solido_data.${month}.prod_term_mes_anterior.valor_total`}
                                                type="text"
                                                component={currency !== 'GTQ' ? renderDollarDisabled : renderCurrencyDisabled}
                                                className="form-control"
                                                placeholder="$ 0.00"
                                            />
                                        </td>
                                    </React.Fragment>
                                );
                            })}
                        </tr>
                        {[
                            { label: "(=) Prod. Term. Disponible", key: "prod_term_disponible", style: ' celda-totales ' },
                            { label: "(-) Costo Vta. Del Mes", key: "costo_vta_del_mes", style: '' },
                            { label: "(=) Prod. Termin. Final", key: "prod_termin_final", style: ' celda-totales ' }
                        ].map((row, rowIndex) => (
                            <tr key={rowIndex}>
                                <td className={row.style + rowDescriptionClassName}>{row.label}</td>
                                {months.map((month, index) => {
                                    const monthClass = index % 2 === 0 ? "" : " month-dark";
                                    return (
                                        <React.Fragment key={index}>
                                            <td className={row.style + monthClass}>
                                                <Field
                                                    name={`solido_data.${month}.${row.key}.kgs_secos`}
                                                    type="text"
                                                    component={renderNumberKGDisabled}
                                                    className="form-control"
                                                    placeholder='0.00'
                                                />
                                            </td>
                                            <td className={row.style + monthClass}>
                                                <Field
                                                    name={`solido_data.${month}.${row.key}.costo_kg_seco`}
                                                    type="text"
                                                    component={currency !== 'GTQ' ? renderDollarDisabled : renderCurrencyDisabled}
                                                    className="form-control"
                                                    placeholder='$0.00'
                                                    decimalScale={5}
                                                />
                                            </td>
                                            <td className={row.style + monthClass + ' tr--border-right'}>
                                                <Field
                                                    name={`solido_data.${month}.${row.key}.valor_total`}
                                                    type="text"
                                                    component={currency !== 'GTQ' ? renderDollarDisabled : renderCurrencyDisabled}
                                                    className="form-control"
                                                    placeholder='$0.00'
                                                />
                                            </td>
                                        </React.Fragment>
                                    )
                                })}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div >
    );
};

const formName = 'CostoVentasForm';

const selector = formValueSelector(formName);

const mapStateToProps = (state) => {
    const data_solido = selector(state, 'solido_data');
    const comparativoData = state.costoDeVentas.comparativoData;
    return {
        data_solido,
        comparativoData
    };
};


export default connect(mapStateToProps)(LatexTable);
